<script setup lang="ts">
import useArticleContent from '../../composables/useArticleContent';

const { articleContent } = useArticleContent();
</script>

<template>
  <div class="help-centers-u__column help-centers-u__column-secondary">
    <h2
      v-if="articleContent.name !== ''"
      class="help-centers-u__article-title"
    >
      {{ articleContent.name }}
    </h2>
    <p
      v-else
      class="help-centers-u__article-placeholder"
    >
      Click on any topic to see the related articles.
    </p>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div
      v-if="articleContent.bodyHtml !== ''"
      v-html="articleContent.bodyHtml"
      class="help-centers-u__article"
    >
    </div>
  </div>
</template>

<style lang="scss">
  @import 'src/main/style/helpCenterColumnsUpdate.scss';
</style>
